import React, { useState } from "react";
import "./image-carousel.css";

interface ImageCarouselProps {
  images: string[];
}

const ImageCarousel: React.FC<ImageCarouselProps> = ({ images }) => {
  const [selectedIndex, setSelectedIndex] = useState<number | null>(null);

  const openImage = (index: number) => setSelectedIndex(index);
  const closeImage = () => setSelectedIndex(null);

  const nextImage = (e: React.MouseEvent) => {
    e.stopPropagation();
    if (selectedIndex !== null)
      setSelectedIndex((selectedIndex + 1) % images.length);
  };

  const prevImage = (e: React.MouseEvent) => {
    e.stopPropagation();
    if (selectedIndex !== null)
      setSelectedIndex((selectedIndex - 1 + images.length) % images.length);
  };

  return (
    <>
      <div className="carousel-container">
        {images.map((img, i) => (
          <img
            key={i}
            src={img}
            alt={`img-${i}`}
            className="carousel-thumbnail"
            onClick={() => openImage(i)}
          />
        ))}
      </div>

      {selectedIndex !== null && (
        <div className="fullscreen-overlay" onClick={closeImage}>
          <button className="nav-button left" onClick={prevImage}>
            ◀
          </button>
          <img
            src={images[selectedIndex]}
            alt={`img-full-${selectedIndex}`}
            className="fullscreen-image"
          />
          <button className="nav-button right" onClick={nextImage}>
            ▶
          </button>
        </div>
      )}
    </>
  );
};

export default ImageCarousel;
